/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { type SelectOption } from '@dm/core/types';

import { UserGroupTpyeE } from '../user-role.enum';
export interface RoleObj {
    TYPE?: number;
    description?: string;
    id: string;
    name: string;
    permitList: string;
    roleOwnerGroup: string;
    roleSource: string;
}

export const roleNameLength = 63;

export const roleDescLength = 255;

export const defaultPermitType = '1';

export const maxRoleLength = 64;

export const pollingPeriod = 30000;

@Injectable()
export class RoleContants {
    constructor(
        private i18nService: I18nService,
    ) {
    }

    groupList: SelectOption[] = [
        {
            label: this.i18nService.get('settings.userAndRole_task_roleManagement_ownGroup_system_value'),
            value: UserGroupTpyeE.System,
        },
        {
            label: this.i18nService.get('settings.userAndRole_task_roleManagement_ownGroup_vstore_value'),
            value: UserGroupTpyeE.Vstore,
        },
    ];

    readAndWritePermitOptions: SelectOption[] = [
        {
            value: '1',
            label: this.createI18n.readOnly,
        },
        {
            value: '2',
            label: this.createI18n.readWrite,
        },
    ];

    readonlyPermitOptions = [
        {
            value: '1',
            label: this.createI18n.readOnly,
        },
    ];

    get roleI18n(): {[key: string]: string} {
        const i18nService = this.i18nService;
        return {
            roleManagerTitle: i18nService.get('settings.userAndRole_RoleManagement_label'),
            roleInfo: i18nService.get('settings.userAndRole_roleManagement_term_desc'),
            roleName: i18nService.get('settings.userAndRole_RoleSetting_RoleName_label'),
            roleSource: i18nService.get('settings.userAndRole_RoleSetting_RoleSource_label'),
            description: i18nService.get('common.description_column'),
            buildInRole: i18nService.get('common.EnumDefine_ROLE_SOURCE_DUFALUT_ROLE'),
            customizedRole: i18nService.get('common.EnumDefine_ROLE_SOURCE_USER_CONFIG_ROLE'),
            createBtn: i18nService.get('common.create_button'),
            modifyBtn: i18nService.get('common.modify_button'),
            deleteBtn: i18nService.get('common.delete_button'),
            defaultNoDataLabel: i18nService.get('noData_label'),
            groupName: i18nService.get('settings.userAndRole_task_roleManagement_ownGroup_lab'),
            maxRoleLength: i18nService.get('settings.userAndRole_roleManagement_task_add_maxQuntity_tip', [maxRoleLength]),
            permitListFailMsg: i18nService.get('rest.getData_permissionList_fail_msg'),
            roleModifyTip: i18nService.get('common.roleManage_task_modify_error_tips'),
            customizationRoleTip: i18nService.get('common.roleManage_task_loginUserNoPermission_error_tips'),
            roleDeleteTip: i18nService.get('common.roleManage_task_delete_error_tips'),
        };
    }

    get detailI18n(): {[key: string]: string} {
        const i18nService = this.i18nService;
        return {
            confirmBtn: i18nService.get('common.confirm_button'),
            closeBtn: i18nService.get('common.close_button'),
            actionBtn: i18nService.get('common.operation_button'),
            modifyBtn: i18nService.get('common.modify_button'),
            deleteBtn: i18nService.get('common.delete_button'),

            roleName: i18nService.get('settings.userAndRole_RoleSetting_RoleName_label'),
            groupName: i18nService.get('settings.userAndRole_task_roleManagement_ownGroup_lab'),
            description: i18nService.get('common.description_column'),
            roleSource: i18nService.get('settings.userAndRole_RoleSetting_RoleSource_label'),
            BasicInfo: i18nService.get('common.basicInfo_title'),
            PermitInfo: i18nService.get('settings.userAndRole_task_roleManagement_addRole_lab'),
            objectLab: i18nService.get('common.object_label'),
            permitLab: i18nService.get('settings.userAndRole_CreateRole_ReadWriteAuthority_label'),
            buildInRole: i18nService.get('common.EnumDefine_ROLE_SOURCE_DUFALUT_ROLE'),
            customizedRole: i18nService.get('common.EnumDefine_ROLE_SOURCE_USER_CONFIG_ROLE'),
            readOnly: i18nService.get('settings.userAndRole_term_readonly_list'),
            readWrite: i18nService.get('settings.userAndRole_term_readWrite_list'),
            writeOnly: i18nService.get('settings.userAndRole_term_writeonly_list'),
        };
    }

    get createI18n(): {[key: string]: string} {
        const i18nService = this.i18nService;
        const i18n = {
            createTitle: i18nService.get('settings.userAndRole_task_roleManagement_createRole1_title'),
            modifyTitle: i18nService.get('settings.userAndRole_task_roleManagement_modifyRole_title'),
            roleName: i18nService.get('settings.userAndRole_RoleSetting_RoleName_label'),
            groupName: i18nService.get('settings.userAndRole_term_ownerGroup_label'),
            description: i18nService.get('common.description_column'),
            BasicInfo: i18nService.get('common.basicInfo_title'),
            PermitInfo: i18nService.get('settings.userAndRole_task_roleManagement_addRole_lab'),
            SelectedObj: i18nService.get('settings.userAndRole_task_roleManagement_addRole_desc'),

            objectLab: i18nService.get('common.object_label'),
            permitLab: i18nService.get('settings.userAndRole_CreateRole_ReadWriteAuthority_label'),
            readOnly: i18nService.get('settings.userAndRole_term_readonly_list'),
            readWrite: i18nService.get('settings.userAndRole_term_readWrite_list'),

            confirmBtn: i18nService.get('common.confirm_button'),
            cancelBtn: i18nService.get('common.cancel_button'),
            closeBtn: i18nService.get('common.close_button'),

            requiredErr: i18nService.get('common.null_validation', [i18nService.get('common.name_column')]),
            roleNameErr: i18nService.get('settings.userAndRole_roleManagement_task_add_roleName_short_tip'),
            permitErr: i18nService.get('settings.userAndRole_roleManagement_task_add_noSelectObject_tip'),
            defaultNoDataLabel: i18nService.get('noData_label'),

            searchPlaceholder: i18nService.get('settings.userAndRole_task_roleManagement_addRole_searchObject_lab'),
            colonLab: i18nService.get('common.colon_label'),
        };
        const roleNameExist = i18nService.get('common.existence_validation', [i18n.roleName]);

        return {
            ...i18n,
            roleNameExist,
        };
    }

    getRoleNameModify(name: string): string {
        return this.i18nService.get('rest.modify_roleName_msg', [name]);
    }

    getRoleDescModify(name: string): string {
        return this.i18nService.get('rest.modify_roleDesc_msg', [name]);
    }

    getPermitRemove(name: string): string {
        return this.i18nService.get('rest.remove_rolePermission_msg', [name]);
    }

    getPermitAdd(name: string): string {
        return this.i18nService.get('rest.add_rolePermission_msg', [name]);
    }

    getLengthMsg(min: number, max: number): string {
        return this.i18nService.get('common.length_msg', [min, max]);
    }

    createRoleMsg(name: string): string {
        return this.i18nService.get('rest.createaRole_msg', [name]);
    }

    deleteCreateRoleMsg(name: string): string {
        return this.i18nService.get('rest.deleteaRole_msg', [name]);
    }
}
